import { GrClose } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import './styles.css';

function EventsModal(props) {
    const { content, title, copyright, link, setOpen } = props;
    const navigate = useNavigate();

    // Função que fecha o modal
    const handleClose = () => {
        if (setOpen) {
            setOpen(false);
        } else {
            navigate('/evento');
        }
    };

    return (
        <>
            <div className="event-modal-background" onClick={handleClose} />
            <div className="event-modal" role="dialog" aria-labelledby="modal-title" aria-modal="true">
                <GrClose className='close-icon' onClick={handleClose} aria-label="Close modal" />
                <h2 id="modal-title" className='case-modal-title'>{title}</h2>
                <div className='content-section'>
                    {content.map((item, index) => {
                        if (item.type === 'image') {
                            const images = Array.isArray(item.src) ? item.src : [item.src];
                            return (
                                <div key={index} className="flex-container">
                                    <div className="modal-image-container image-container">
                                        {images.map((src, imgIndex) => (
                                            <img
                                                key={imgIndex}
                                                src={src}
                                                alt={item.alt || 'Imagem do projeto'}
                                                className="event-modal-image events-modal-img"
                                            />
                                        ))}
                                    </div>
                                    {index + 1 < content.length && content[index + 1].type === 'text' && (
                                        <div className="text-section">
                                            <p>{content[index + 1].text}</p>
                                        </div>
                                    )}
                                </div>
                            );
                        } else if (item.type === 'text' && (index === 0 || content[index - 1].type !== 'image')) {
                            // Verifica se este texto não é imediatamente após uma imagem
                            // Se for o primeiro texto ou se o item anterior não for uma imagem, mostra o texto
                            return (
                                <div key={index} className="text-section">
                                    <p>{item.text}</p>
                                </div>
                            );
                        } else if (item.type === 'link') {
                            return (
                                <div key={index} className="link-section">
                                    <a
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="event-link"
                                    >
                                        {item.text || item.url}
                                    </a>
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
                {link && (
                    <div className="event-links">
                        <h3>Links:</h3>
                        <ul>
                            {Array.isArray(link) ? (
                                link.map((linkItem, idx) => (
                                    <li key={idx}>
                                        <a
                                            href={linkItem.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {linkItem.text}
                                        </a>
                                    </li>
                                ))
                            ) : (
                                <li>
                                    <a
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {link.text}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                )}
                {copyright && <p className='copyright'>{copyright}</p>}
            </div>
        </>
    );
}

export default EventsModal;
